export const isNativeApp = () => !!window.Capacitor;
export const isIOS = () => window.Capacitor?.getPlatform?.() === 'ios';
export const isAndroid = () => window.Capacitor?.getPlatform?.() === 'android';
